export function getEnv(origin: string) {
  const envList = ['prod', 'dev', 'test', 'sit'];
  return envList.find(item => origin.indexOf(item) > -1) ?? 'prod';
}
